import { observer } from 'mobx-react'
import { useEffect, useState } from 'react'
import './index.scss'
import { ReactComponent as Package } from '../../../../assets/track/package.svg'
import { ReactComponent as Arrows } from '../../../../assets/track/chevrons-right.svg'
import { ReactComponent as Number } from '../../../../assets/track/Group 99.svg'
import { ReactComponent as Close } from '../../../../assets/track/close.svg'
import { ReactComponent as Share } from '../../../../assets/track/link.svg'
import base64 from 'base-64'
import classNames from 'classnames'
import {
  getDateOut,
  getDay,
  getShortDate,
  getStart,
  getTime,
} from '../../../../hooks/dateOutputs'
import { useParams } from 'react-router'
import ContentState from '../../../../stores/ContentState'
import GlobalState from '../../../../stores/GlobalState'
import { encode } from 'punycode'
import { ReCAPTCHAv3Utils } from '../../login2/FirstStep'
const TrackingContent = observer(() => {
  const errorTrackingCodes = [
    '521-1',
    '405',
    '540',
    '541',
    '551',
    '511',
    '552',
    '514',
    '33',
    '532',
    '553',
    '34',
    '31',
    '714',
    '613',
    '521-2',
    '521-3',
    '521-4',
    '521-5',
    '518',
    '545',
    '562',
    '563',
    '787',
  ]

  const [history, setHistory] = useState<any>([])

  const [data, setData] = useState<any>(0)
  const [state, setState] = useState('')
  const [copy, setCopy] = useState(false)

  const track = async (number: string) => {
    if (
      document
        .querySelector('.tracking .button.black')
        ?.classList.contains('button-active')
    ) {
      setTimeout(() => {
        document
          .querySelector('.tracking .button.black')
          ?.classList.toggle('button-active')
      }, 500)
    } else {
      document
        .querySelector('.tracking .button.black')
        ?.classList.toggle('button-active')
      setTimeout(() => {
        document
          .querySelector('.tracking .button.black')
          ?.classList.toggle('button-active')
      }, 500)
    }

    if (!number.length) return

    var onSuccess = function (token: any) {
      const fd = new FormData()
      fd.append('num', number.toString())
      fd.append('token', token)
      fd.append('lang', GlobalState.currentLocale.lang)
      fetch('https://preprod.novaposhtaglobal.com/tracking.php', {
        method: 'POST',
        body: fd,
      })
        .then((response) => response.json())
        .then(
          (result) => {
            if (localStorage.getItem('trackingHistory')) {
              const dt = JSON.parse(localStorage.getItem('trackingHistory')!)
              dt.push({
                date: result.date,
                numberBill: result.billNumber,
              })
              localStorage.setItem('trackingHistory', JSON.stringify(dt))
              setHistory(dt)
            } else {
              localStorage.setItem(
                'trackingHistory',
                JSON.stringify([
                  {
                    date: result.date,
                    numberBill: result.billNumber,
                  },
                ]),
              )
              setHistory([
                {
                  date: result.date,
                  numberBill: result.billNumber,
                },
              ])
            }

            setData(result)
          },
          (error) => {
            setData(null)
            const date = `${new Date().getFullYear()}/${
              new Date().getMonth() + 1
            }/${new Date().getDate()}, ${new Date().getHours()}:${new Date().getMinutes()}:${new Date().getSeconds()}`
            if (localStorage.getItem('trackingHistory')) {
              const dt = JSON.parse(localStorage.getItem('trackingHistory')!)
              dt.push({
                date: date,
                numberBill: state,
              })
              localStorage.setItem('trackingHistory', JSON.stringify(dt))
              setHistory(dt)
            } else {
              localStorage.setItem(
                'trackingHistory',
                JSON.stringify([
                  {
                    date: date,
                    numberBill: state,
                  },
                ]),
              )
              setHistory([
                {
                  date: date,
                  numberBill: state,
                },
              ])
            }
          },
        )
    }
    var onError = function (message: any) {
      alert('Error: ' + message)
    }
    ReCAPTCHAv3Utils('track', onSuccess, onError)
  }

  const share = () => {
    if (
      document
        .querySelector('.tracking .button.grey-border')
        ?.classList.contains('button-active')
    ) {
      setTimeout(() => {
        document
          .querySelector('.tracking .button.grey-border')
          ?.classList.toggle('button-active')
      }, 500)
    } else {
      document
        .querySelector('.tracking .button.grey-border')
        ?.classList.toggle('button-active')
      setTimeout(() => {
        document
          .querySelector('.tracking .button.grey-border')
          ?.classList.toggle('button-active')
      }, 500)
    }

    navigator.clipboard
      //track
      .writeText(`${window.location.origin}/track/?Tracking_ID=${state}`)
      .then(() => setCopy(true))
  }

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (!params.get('Tracking_ID')) return

    setState(params.get('Tracking_ID')!)
    track(params.get('Tracking_ID')!)
  }, [])

  useEffect(() => {
    if (copy) {
      setTimeout(() => {
        setCopy(false)
      }, 3000)
    }
  }, [copy])

  const clearHistory = () => {
    localStorage.removeItem('trackingHistory')
    setHistory([])
  }

  const deleteItem = (id: number) => {
    setHistory(history.filter((h: any, i: number) => i != id))
    const items = document.querySelectorAll('.tracking__history-item')
    const close = items[id].querySelector('.tracking__close')
    if (close?.classList.contains('close-active')) {
      setTimeout(() => {
        close?.classList.toggle('close-active')
      }, 500)
    } else {
      close?.classList.toggle('close-active')
      setTimeout(() => {
        close?.classList.toggle('close-active')
      }, 500)
    }
    localStorage.setItem(
      'trackingHistory',
      JSON.stringify(history.filter((h: any, i: number) => i != id)),
    )
  }

  useEffect(() => {
    if (localStorage.getItem('trackingHistory')) {
      const dt = JSON.parse(localStorage.getItem('trackingHistory')!)
      setHistory(dt)
    }
  }, [])

  const dates =
    (history.length &&
      new Set(
        history?.map((item: any) => {
          return new Date(getStart(item.date)).getTime()
        }),
      )) ||
    []

  const getItems = (date: number) => {
    if (!history.length) return []
    let items = history?.filter((item: any) => {
      if (new Date(new Date(item.date).toDateString()).getTime() == date)
        return item
    })

    items = items.sort((a: any, b: any) => a.id - b.id)

    return items
  }

  if (!ContentState.tracking) return <></>

  const content: any = ContentState.tracking

  return (
    <section
      className="tracking"
      style={content.bg ? { backgroundImage: `url(${content.bg})` } : {}}
    >
      <div className="tracking__container">
        <div className="tracking__row">
          <div className={classNames('tracking__form', data && 'fill')}>
            <div
              className="tracking__title"
              dangerouslySetInnerHTML={{
                __html:
                  window.innerWidth > 768 ? content.title : content.mobTitle,
              }}
            ></div>
            <div className="tracking__form-row">
              <div
                className={classNames(
                  'tracking__input',
                  data == null && 'error',
                )}
              >
                <input
                  maxLength={40}
                  value={state}
                  className="input"
                  onChange={(e) => {
                    if (e.target.value.includes(' ')) {
                      return
                    } else setState(e.target.value)
                  }}
                />
                <Close
                  onClick={() => {
                    const close = document.querySelector(
                      '.tracking__input .tracking__close',
                    )

                    if (close?.classList.contains('close-active')) {
                      setTimeout(() => {
                        close?.classList.toggle('close-active')
                      }, 500)
                    } else {
                      close?.classList.toggle('close-active')
                      setTimeout(() => {
                        close?.classList.toggle('close-active')
                      }, 500)
                    }
                    setState('')
                  }}
                  className="tracking__close close-active"
                />
              </div>
              <div
                className="button black button-active"
                onClick={() => track(state)}
              >
                {content.buttonTitle}
              </div>
            </div>
          </div>
          {!data && data != null && (
            <div className="tracking__imgs">
              {content.imgs.map((i: any, id: number) => (
                <a href={i.link} target="__blank" key={id}>
                  <img src={i.src} key={id} />
                </a>
              ))}
            </div>
          )}
          {data == null ? (
            <div className="tracking__error">
              <img className="tracking__error-icon" src={content.error.icon} />
              <div
                className="tracking__error-text"
                dangerouslySetInnerHTML={{ __html: content.error.text }}
              ></div>
            </div>
          ) : (
            <></>
          )}
          {data ? (
            <div className="tracking__bill">
              <div className="tracking__bill-title ">
                {content.bill.title} {data.billNumber}
              </div>

              <div
                className={classNames(
                  'tracking__bill-row tracking__bill-text',
                  errorTrackingCodes.includes(data.historyStatus[0].code) &&
                    'error',
                  data.historyStatus[0].code == '3-1' && 'recieved',
                )}
              >
                <Package
                  className={classNames(
                    'tracking__bill-icon',
                    errorTrackingCodes.includes(data.historyStatus[0].code) &&
                      'error',
                    data.historyStatus[0].code == '3-1' && 'recieved',
                  )}
                />{' '}
                <div className="tracking__bill-col">
                  {data.historyStatus[0].status}
                  <span className="tracking__bill-separator"></span>
                  <span className="tracking__bill-country">
                    {data.location}
                  </span>
                  <span className="tracking__bill-separator"></span>
                  {getDateOut(data.date)}
                </div>
              </div>
              <div
                className={classNames('tracking__bill-row tracking__bill-text')}
              >
                <Arrows className="tracking__bill-arrows" />{' '}
                <div className="tracking__bill-route">
                  <TrackingFlag name={data.from} byName={false} /> {data.from}
                </div>{' '}
                <span className="tracking__bill-separator bill-route"></span>
                <div className="tracking__bill-route">
                  <TrackingFlag name={data.to} byName={false} /> {data.to}
                </div>
              </div>
              <div className="tracking__bill-row tracking__bill-text">
                <Number className="tracking__bill-icon" /> {data.bills}
              </div>

              <div className="tracking__bill-bottom">
                <div
                  className="button white grey-border button-active"
                  onClick={share}
                >
                  <Share /> {content.bill.share}
                </div>
                <div
                  className={classNames(
                    'tracking__bill-copy',
                    copy && 'visible',
                  )}
                >
                  {content.bill.copy}
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
        {data ? (
          <div className="tracking__row">
            {data ? (
              <div className="tracking__statuses">
                <div className="tracking__statuses-title ">
                  {content.statuses.title}
                </div>
                <div className="tracking__statuses-list">
                  {data.historyStatus.map((hi: any, id: number) => (
                    <div
                      className={classNames(
                        'tracking__statuses-item',
                        id + 1 == data.historyStatus.length && 'start',
                        !id && 'start',
                        errorTrackingCodes.includes(hi.code) && !id && 'error',
                        hi.code == '3-1' && !id && 'recieved',
                      )}
                      key={id}
                    >
                      <div className="tracking__bill-text">{hi.status}</div>
                      <div className="tracking__statuses-row">
                        <TrackingFlag name={hi.location} byName={false} />
                        {hi.location}{' '}
                        <span className="tracking__bill-separator"></span>{' '}
                        {getDateOut(hi.date)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <></>
        )}
        {history.length ? (
          <div className="tracking__row">
            <div className="tracking__history">
              <div className="tracking__history-top">
                <div className="tracking__history-title">
                  {content.history.title}
                </div>
                <div className="tracking__history-clear" onClick={clearHistory}>
                  {window.innerWidth > 480
                    ? content.history.clear
                    : content.history.clearMob}
                </div>
              </div>
              {Array.from(dates).map((d: any, i) => (
                <div className="tracking__history-block" key={i}>
                  <div className="tracking__history-sort">
                    {getDay(d, content)},{' '}
                    {getShortDate(d, content, GlobalState.currentLocale.lang)}
                  </div>

                  {getItems(d).map((item: any, index: number) => (
                    <div className="tracking__history-item" key={index}>
                      <div className="tracking__history-time">
                        {getTime(item.date)}
                      </div>
                      <div className="tracking__history-number">
                        {item.numberBill.length > 20
                          ? `${item.numberBill.slice(0, 20)}${'...'}`
                          : item.numberBill}
                      </div>
                      <Close
                        onClick={() => deleteItem(index)}
                        className="tracking__close close-active"
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </section>
  )
})

export default TrackingContent

export const TrackingFlag = observer(
  ({ name, byName }: { name: string; byName: boolean }) => {
    const [img, setImg] = useState('')
    useEffect(() => {
      if (byName) {
        fetch(`https://restcountries.com/v3.1/name/${name}?fields=flags`)
          .then((response) => response.json())
          .then((result) => {
            if (result.status) {
              return
            }
            if (result[0].flags) {
              if (result[0].flags.png) {
                setImg(result[0].flags.png)
              } else setImg(result[0].flags.svg)
            }
          })
        return
      }
      fetch(`https://restcountries.com/v3.1/alpha/${name}?fields=flags`)
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            return
          }
          if (result.flags) {
            if (result.flags.png) {
              setImg(result.flags.png)
            } else setImg(result.flags.svg)
          }
        })
    }, [name])
    return <img src={img} />
  },
)
